import clsx from "clsx";
import { Link } from "react-router-dom";

const baseStyles = {
  solid:
    "group inline-flex gap-1 items-center justify-center rounded-md py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2",
  outline:
    "group inline-flex gap-1 ring-1 ring-slate-300 shadow items-center justify-center rounded-md py-2 px-4 text-sm focus:outline-none",
};

const variantStyles = {
  solid: {
    primary:
      "bg-blue-600 text-white hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
    slate:
      "bg-slate-900 text-white hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
    purple:
      "bg-purple-600 text-white hover:text-slate-100 hover:bg-purple-500 active:bg-purple-800 active:text-purple-100 focus-visible:outline-purple-600",
    danger:
      "bg-red-600 text-white hover:text-slate-100 hover:bg-red-500 active:bg-red-800 active:text-red-100 focus-visible:outline-red-600",
    white:
      "bg-white text-slate-900 hover:bg-purple-50 active:bg-purple-200 active:text-slate-600 focus-visible:outline-white",
  },
  outline: {
    slate: "font-bold ring-slate-200",
    primary: "text-blue-600 ring-blue-400 font-semibold",
    white:
      "ring-slate-700 text-white hover:ring-slate-500 active:ring-slate-700 active:text-slate-400 focus-visible:outline-white",
  },
};

export default function Button({ className = null, ...props }) {
  props.variant ??= "solid";
  props.color ??= "primary";

  className = clsx(
    baseStyles[props.variant],
    props.variant === "outline"
      ? variantStyles.outline[props.color]
      : props.variant === "solid"
      ? variantStyles.solid[props.color]
      : undefined,
    props.disabled
      ? "cursor-not-allowed bg-slate-400 hover:bg-slate-500"
      : "cursor-pointer",
    className,
    'flex-shrink-0'
  );

  return typeof props.href === "undefined" ? (
    <button className={className} disabled={props.disabled} {...props} />
  ) : (
    <Link className={className} {...props} to={props.href} />
  );
}
